<template>
  <label class="switch" :disabled="disabled">
    <input
      class="switch__input"
      type="checkbox"
      :checked="onCheck"
      :name="name"
      :disabled="disabled"
      @change="toggleCheck"
    >

    <span class="switch__custom" />

    <span v-if="title" class="switch__text">
      {{ title }}
    </span>
  </label>
</template>

<script>
export default {
  name: 'app-switch',
  props: {
    name: String,
    title: String,
    disabled: Boolean,
    onCheck: Boolean
  },
  methods: {
    toggleCheck () {
      this.$emit('toggleCheck')
    }
  }
}
</script>
